// On a phone a table becomes a list, each row a line of it (BasePhoneTable), and each column has a
// part in that line: the title, a line under it (subtitle), a tag on the line of tags (meta), a
// "label · value" fact, a block across the row under its label (for wide content), the row's
// actions in its corner, or nothing (hidden). A page sets `phone` on a header to choose; without
// it, an `actions` column holds the actions, a column without a name is a tag, the first column
// with a name is the title and any other a fact.
export const PHONE_ROLES = Object.freeze(['title', 'subtitle', 'meta', 'fact', 'block', 'actions', 'hidden']);

// Rows a phone list adds at a time, the size of a page of the server's.
export const PHONE_PAGE_SIZE = 25;

// Vuetify's own columns (row selection and expansion) have no place in the line.
const OWN_COLUMNS = ['data-table-select', 'data-table-expand'];

const defaultRole = (header) => {
  if (header.value === 'actions') return 'actions';
  if (!header.text) return 'meta';
  return 'fact';
};

// The columns a line shows, with their part, in the table's order.
export const phoneColumns = (headers) => {
  const columns = headers
    .filter((header) => !OWN_COLUMNS.includes(header.value))
    .map((header) => ({ header, role: PHONE_ROLES.includes(header.phone) ? header.phone : defaultRole(header) }));
  if (!columns.some((column) => column.role === 'title')) {
    const first = columns.find((column) => column.role === 'fact' && !column.header.phone);
    if (first) first.role = 'title';
  }
  return columns.filter((column) => column.role !== 'hidden');
};

// What the reader can sort by: the columns the line shows by name and that sort.
export const phoneSortOptions = (columns, label) =>
  columns
    .filter(({ header, role }) => role !== 'actions' && header.text && header.sortable !== false)
    .flatMap(({ header }) => [
      { key: `${header.value}:asc`, by: header.value, desc: false, label: label(header.text, false) },
      { key: `${header.value}:desc`, by: header.value, desc: true, label: label(header.text, true) },
    ]);

// A value of an item by its column's path ("owner.name"), as the table reads it.
export const valueAt = (item, path) =>
  String(path)
    .split('.')
    .reduce((value, key) => (value == null ? undefined : value[key]), item);
